import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { initGtm, trackPageview } from './gtm';
import { initLinkClickTracking } from './events';
import { captureFirstTouch } from './attribution';

/**
 * Loads the GTM container once on mount and reports every React Router route
 * change as an `spa_pageview` dataLayer event. Also binds global tel:/mailto:
 * click tracking. Renders nothing. Must live inside <BrowserRouter> (it calls
 * useLocation). The GTM container is gated on VITE_GTM_ID, but the dataLayer
 * events (pageviews, key events) always emit so they're ready when GTM loads.
 */
export default function GoogleTagManager() {
  const location = useLocation();

  useEffect(() => {
    initGtm();
    initLinkClickTracking();
    // Must run on the LANDING render, before any route change: the UTMs and the
    // referrer only exist on the page the visitor actually arrived at.
    captureFirstTouch();
  }, []);

  useEffect(() => {
    trackPageview(location.pathname + location.search);
  }, [location.pathname, location.search]);

  return null;
}
